import isMobileWeb from 'is-mobile';
import * as qs from 'qs';
import { useLocation } from 'react-router';

import type { Sport } from '#src/__generated__/globalTypes.ts';
import { SignupPlatform } from '#src/__generated__/globalTypes.ts';
import { localStorage } from '#src/lib/storage/localStorage.ts';

import { useAfterLoggedInTarget } from './useAfterLoggedInTarget.ts';
import { useIsMobileApp } from './useIsMobileApp.ts';
import { useQueryString } from './useQueryString.ts';

type Props = {
  sport?: Sport;
};

export const useOAuthParams = ({ sport }: Props) => {
  const action = useQueryString('action');
  const location = useLocation();
  const afterLoggedInTarget = useAfterLoggedInTarget();
  const { isMobileApp, isAndroidApp } = useIsMobileApp();

  const signupPlatform = (() => {
    if (isMobileApp && isAndroidApp) return SignupPlatform.ANDROID;
    if (isMobileWeb()) return SignupPlatform.MOBILE_WEB;
    return SignupPlatform.WEB;
  })();

  return {
    referrer: localStorage.getItem('REFERRER'),
    referrer_code: localStorage.getItem('REFERRER_CODE'),
    signup_platform: signupPlatform,
    signup_sport: sport,
    impact_click_id: localStorage.getItem('IMPACT_CLICKID'),
    google_click_id: localStorage.getItem('GOOGLE_CLICKID'),
    facebook_click_id: localStorage.getItem('FACEBOOK_CLICKID'),
    twitter_click_id: localStorage.getItem('TWITTER_CLICKID'),
    tik_tok_click_id: localStorage.getItem('TIKTOK_CLICKID'),
    snapchat_click_id: localStorage.getItem('SNAPCHAT_CLICKID'),
    reddit_click_id: localStorage.getItem('REDDIT_CLICKID'),
    invitation_token: localStorage.getItem('INVITATION_TOKEN'),
    utm_campaign: localStorage.getItem('UTM_CAMPAIGN'),
    utm_source: localStorage.getItem('UTM_SOURCE'),
    utm_medium: localStorage.getItem('UTM_MEDIUM'),
    utm_term: localStorage.getItem('UTM_TERM'),
    utm_content: localStorage.getItem('UTM_CONTENT'),
    partner: localStorage.getItem('PARTNER'),
    user: localStorage.getItem('USER'),
    traffic_category: localStorage.getItem('TRAFFIC_CATEGORY'),
    after_logged_in_target:
      afterLoggedInTarget ||
      (action
        ? qs.stringify({ action }, { skipNulls: true, addQueryPrefix: true })
        : location.pathname),
  };
};
